/**
 * @fileoverview Sentry-wrapped React Router Route component for error tracking.
 */

import {Route} from "react-router-dom";
import * as Sentry from "@sentry/react";

/**
 * React Router Route component wrapped with Sentry error tracking.
 * Automatically captures routing errors and performance data.
 */
export const SentryRoute = Sentry.withSentryRouting(Route);
